"use client";

import React from "react";
import { Mouse, ShieldCheck, Clock, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GlobalLogisticsSimplified() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const stats = [{
    icon: Clock,
    label: "100+ Years",
    sub: "of Heritage"
  }, {
    icon: ShieldCheck,
    label: "Certified",
    sub: "Master Techs"
  }, {
    icon: Wrench,
    label: "Modern",
    sub: "Diagnostics"
  }];
  return <section data-section-id="245070" id="albanys-trusted-hands-since-1924" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/vintage_garage_interior.png)] bg-cover bg-center grayscale-[0.4] opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/40 to-background !bg-[url(https://dottsgarage.com/wp-content/uploads/2026/05/Untitled-design-1.png)] !bg-[url(https://dottsgarage.com/wp-content/uploads/2026/05/Untitled-design-2.png)]" />
        
        {}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(var(--primary) 1px, transparent 1px), linear-gradient(90deg, var(--primary) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} />
      </div>

      {}
      <div ref={contentRef} className={`relative z-10 container mx-auto px-4 md:px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="mb-8 inline-flex items-center gap-3 px-4 py-1.5 rounded-full border border-primary/10 bg-primary/5 backdrop-blur-sm">
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          <span className="font-serif italic text-primary text-sm md:text-base">Serving Albany Since 1921</span>
        </div>

        <h1 className="font-sans font-bold text-5xl sm:text-7xl md:text-8xl lg:text-9xl text-primary tracking-tighter mb-8 max-w-6xl leading-[0.9] uppercase">local auto<br /><span className="text-transparent bg-clip-text bg-gradient-to-b from-primary to-primary/60" data-ast-id="f:/src/pages/Home/sections/GlobalLogisticsSimplified.tsx|sig:g7kv4e" data-ast-start="2496" data-ast-end="2761" contenteditable="false">experts</span></h1>

        <p className="text-lg text-foreground/70 max-w-2xl mb-12 font-sans leading-relaxed !font-bold sm:text-xl md:text-2xl">
          Dott's Garage blends a century of mechanical heritage with cutting-edge 
          technology to keep Albany's drivers moving forward.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-5 w-full sm:w-auto mb-20">
          <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-10 rounded-md bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg transition-all duration-300 group">
            <Link to="https://dottsgarage.com/book-appointment/">
              Schedule Service
              <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
            </Link>
          </Button>
          <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-10 rounded-md bg-[rgba(12,55,30,1)] hover:bg-[rgba(12,55,30,0.9)] text-white font-bold shadow-lg transition-all duration-300">
            <Link to="https://dottsgarage.com/sell-my-car/">Sell My Car</Link>
          </Button>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-16 w-full max-w-4xl border-t border-primary/10 pt-12">
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center gap-2">
              <stat.icon className="w-6 h-6 text-primary/60 mb-1" />
              <span className="font-sans font-bold text-xl uppercase tracking-tight text-primary">
                {stat.label}
              </span>
              <span className="text-xs uppercase tracking-widest text-foreground/50 font-medium">
                {stat.sub}
              </span>
            </div>)}
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-3 animate-bounce opacity-40">
        <Mouse className="w-5 h-5 text-primary" />
        <div className="w-px h-8 bg-gradient-to-b from-primary to-transparent" />
      </div>
    </section>;
}